import { calendarDetailed } from '@app/pcs/models';
import {gql} from 'apollo-angular';

export const calendarResult = 'calendar';
export const calendarQuery = gql`
  query Calendar ($id: Long!, $validityPeriod: ValidityPeriodInput!) {
    calendar (id: $id, validityPeriod: $validityPeriod) {
      ...calendarDetailed
    }
  }
  ${calendarDetailed}
`;
